/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_About_HdInputs */

const de_commons_footer_about_hd = /** @type {(inputs: Commons_Footer_About_HdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD-Fernsehen`)
};

/** @type {(inputs: Commons_Footer_About_HdInputs) => LocalizedString} */
const en_commons_footer_about_hd = de_commons_footer_about_hd;

/**

* @param {Commons_Footer_About_HdInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_about_hd = /** @type {((inputs?: Commons_Footer_About_HdInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_About_HdInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_about_hd(inputs)
	return en_commons_footer_about_hd(inputs)
});